import { Trans, useTranslation } from 'react-i18next';
import styles from './checkoutLayout.module.scss';
import { legalLinks } from './data';

export function LegalNotice() {
  const { t } = useTranslation();

  return (
    <div className={styles.legal}>
      <div>
        {/* biome-ignore-start lint/a11y/useAnchorContent: Trans fills each anchor at render time */}
        <Trans
          i18nKey="By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>."
          components={{
            privacy: (
              <a href={legalLinks.privacy} target="_blank" rel="noreferrer" />
            ),
            terms: (
              <a href={legalLinks.terms} target="_blank" rel="noreferrer" />
            ),
            eula: <a href={legalLinks.eula} target="_blank" rel="noreferrer" />,
          }}
        />
        {/* biome-ignore-end lint/a11y/useAnchorContent: Trans fills each anchor at render time */}
      </div>
      <div>
        {t(
          'All Chaos products are intended for professional use only and not for consumer use.',
        )}
      </div>
    </div>
  );
}
